import {capValue, roundValue} from '@/utils/misc';

export function getStandardScore(mu: number) {
    return roundValue(capValue(mu, 1, 10), 0);
}
